import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ReportsComponent} from './reports.component';

const reportsRoute: Routes = [
    {
        path: '',
        component: ReportsComponent,
    },
    {path: '', redirectTo: '/', pathMatch: 'full'},
    {
        path: '**',
        redirectTo: '/',
        pathMatch: 'full',
    }
]

@NgModule({
    imports: [RouterModule.forChild(reportsRoute)],
    exports: [RouterModule]
})
export class ReportsRoutingModule {
}
